import { useEffect, useState } from 'react';
import { isNullOrUndefined } from 'utility/generalHelper';

import AppRoot from 'packages/kakapo-ui-application/common/containers/AppRoot';
import I18nFactory from 'packages/kakapo-ui-services/factories/I18nFactory';
import ConfigService, {
	ITenantConfig,
} from 'packages/kakapo-ui-services/services/common/ConfigService';
import Nullable from 'packages/kakapo-ui-services/types/Nullable';
import FullPageLoadingContainer from '../pages/loading/FullPageLoadingContainer';

export default function ConfigGuard() {
	const [initialized, setInitialized] = useState<boolean>(false);
	const [error, setError] = useState<Nullable<Error>>(null);
	const [tenantConfig, setTenantConfig] = useState<ITenantConfig>();

	const initialize = async () => {
		try {
			const config = await ConfigService.fetchConfigForHost(
				window.location.host,
				process.env.NODE_ENV === 'development',
			);
			if (config !== undefined) {
				setTenantConfig(config);
			}
		} catch (e) {
			setError(e);
		}
	};

	useEffect(() => {
		initialize();
	}, []);

	useEffect(() => {
		if (tenantConfig === null || tenantConfig === undefined) {
			return;
		}
		setInitialized(true);
	}, [tenantConfig]);

	useEffect(() => {
		if (tenantConfig === null || tenantConfig === undefined) {
			return;
		}
		I18nFactory.create(tenantConfig!);
	}, [tenantConfig]);

	if (!isNullOrUndefined(error)) {
		return <div className="page-content">{error!.message}</div>;
	}

	if (!initialized) {
		return <FullPageLoadingContainer />;
	}

	return <AppRoot />;
}
